import './DatePicker.scss'
import {useDispatch, useSelector} from "react-redux";
import {useRouteMatch} from "react-router-dom";
import {getDateFilter, setDateFilter} from "../../../ducks/assets-duck.js";
import {getHistoryArray} from "../../../ducks/history-duck.js";
import {getTodayString, isToday} from "../../../util/time-and-date.js";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon.js";
import ChevronRightIcon from "mdi-react/ChevronRightIcon.js";
import dayjs from "dayjs";
import {APP_ROUTES} from "../../../App.jsx";

export default () => {

    const dispatch = useDispatch()
    const dateFilter = useSelector(getDateFilter)
    const history = useSelector(getHistoryArray)
    const isOnAssetList = !useRouteMatch([
        APP_ROUTES.history,
        APP_ROUTES.transactionsAddBulk,
        APP_ROUTES.transactionsAdd,
        APP_ROUTES.transactionsPage,
        APP_ROUTES.transactions,
        APP_ROUTES.stats,
        APP_ROUTES.settings,
        APP_ROUTES.analysis,
        APP_ROUTES.compare,
        APP_ROUTES.applyHoverDateFilter,
    ])

    const date = dateFilter || getTodayString()
    const earliestDate = history[0]?.[0]

    const canGoBack = !earliestDate || date > earliestDate
    const canGoForward = !isToday(date)

    const shiftDate = amount => {
        const nextDate = dayjs(date).add(amount, 'day').format('YYYY-MM-DD')
        dispatch(setDateFilter(isToday(nextDate) ? null : nextDate))
    }

    return isOnAssetList && (
        <div className='date-picker'>
            <button
                className='shift-date'
                disabled={!canGoBack}
                onClick={() => shiftDate(-1)}
            >
                <ChevronLeftIcon/>
            </button>
            <div className={`current-date ${!canGoForward && 'disabled'}`}>
                <div className='date'>
                    {date}
                </div>
            </div>
            <button
                className='shift-date'
                disabled={!canGoForward}
                onClick={() => shiftDate(1)}
            >
                <ChevronRightIcon/>
            </button>
        </div>
    )
}